import React, { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import PageMeta from '../components/PageMeta'

const DataDeletionPage = () => {
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    // In production, this would send to your backend
    setSubmitted(true)
  }

  return (
    <div>
      <PageMeta 
        title="Data Deletion Request | RDS Studio"
        description="Request deletion of your data from RDS Studio services and Facebook integration."
        canonical="https://rdsstudio.co.za/data-deletion"
      />
      <Header />
      <main className="main-content">
        <section className="section legal-page">
          <div className="section-inner">
            <h1 className="title title-h2">Data Deletion Request</h1>
            
            {!submitted ? (
              <>
                <p className="description">
                  If you've used Facebook to interact with RDS Studio and want to delete your data, 
                  please submit a request below. We will process your request within 30 days as required by GDPR.
                </p>

                <div className="legal-content">
                  <h2>What Data We Delete</h2>
                  <ul>
                    <li>Facebook user ID and profile information</li>
                    <li>Any data collected through Facebook integration</li>
                    <li>Activity logs related to Facebook authentication</li>
                    <li>Any other personal data associated with your Facebook account</li>
                  </ul>

                  <h2>Submit Deletion Request</h2>
                  
                  <form onSubmit={handleSubmit} className="contact-form" style={{ maxWidth: '600px', margin: '2rem 0' }}>
                    <div className="form-group">
                      <label htmlFor="facebook_id">Facebook User ID (optional)</label>
                      <input
                        type="text"
                        id="facebook_id"
                        name="facebook_id"
                        placeholder="Your Facebook User ID if known"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        placeholder="Your email address"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="details">Additional Details</label>
                      <textarea
                        id="details"
                        name="details"
                        rows="4"
                        placeholder="Any additional information to help us locate your data"
                      ></textarea>
                    </div>

                    <button type="submit" className="btn btn-primary">
                      Submit Deletion Request
                    </button>
                  </form>

                  <h2>Alternative Methods</h2>
                  <p>You can also request data deletion by:</p>
                  <ul>
                    <li>
                      <strong>Email:</strong> <a href="mailto:info@rdsstudio.co.za?subject=Data Deletion Request">info@rdsstudio.co.za</a> with subject "Data Deletion Request"
                    </li>
                    <li>
                      <strong>Contact Form:</strong> <a href="/contact">Use our contact form</a> with "Data Deletion Request" in the subject
                    </li>
                  </ul>

                  <h2>Response Time</h2>
                  <p>
                    We will acknowledge your request within 72 hours and complete the deletion within 30 days. 
                    You will receive confirmation once your data has been deleted.
                  </p>

                  <h2>Questions?</h2>
                  <p>
                    If you have any questions about data deletion, please contact us at{' '}
                    <a href="mailto:info@rdsstudio.co.za">info@rdsstudio.co.za</a>
                  </p>
                </div>
              </>
            ) : (
              <div className="legal-content">
                <div style={{ 
                  background: 'rgba(45, 212, 191, 0.1)', 
                  border: '1px solid var(--color-accent)',
                  borderRadius: '8px',
                  padding: '2rem',
                  textAlign: 'center',
                  margin: '2rem 0'
                }}>
                  <h2 style={{ color: 'var(--color-accent)', marginBottom: '1rem' }}>Request Submitted</h2>
                  <p>
                    Thank you. We have received your data deletion request and will process it within 30 days. 
                    You will receive a confirmation email once the deletion is complete.
                  </p>
                  <p style={{ marginTop: '1rem' }}>
                    <a href="/" className="btn btn-secondary">Return Home</a>
                  </p>
                </div>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default DataDeletionPage
